<template>
  <div class="template">

    <h3>Stockholm kring sekelskiftet 1700/1800</h3>

    <p>
      I kartan nedan från 1805, 13 år efter mordet på Gustav III, presenteras några av de platser som spelar en central roll i C.J.L. Almqvists roman.
    </p>
    <p class="instructions">
      Såhär gör du: Använd pilarna för att navigera framåt i såväl historien som i kartan, eller klicka direkt på någon av kartmarkörerna.
    </p>

    <!--iframe src="https://uploads.knightlab.com/storymapjs/db45421ba57b3b0a034b7452b679abb5/drottningens-juvelsmycke/index.html" frameborder="0" width="100%" height="600"></iframe-->
    <iframe src="https://uploads.knightlab.com/storymapjs/f1eac7a14dcb0ad4e890962810da0c9e/drottningens-juvelsmycke/index.html" frameborder="0" width="100%" height="600"></iframe>

  </div>
</template>

<script>
export default {
  name: 'DJMap',
  readable: 'Karta',
  route: 'karta',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.border{
  border: 1px solid gray;
}

</style>



// WEBPACK FOOTER //
// src/components/objects/drottningensjuvelsmycke/tabs/DJMap.vue